<div class="modal-header">
  <h4 class="modal-title">{{ "layout.aboutModal.title" | translate }}</h4>
  <button type="button" class="btn-close" (click)="close()"></button>
</div>
<div class="modal-body text-center py-4">
  <img
    src="/assets/images/trendmulti@4x.png"
    alt="Trendmulti"
    height="40"
    class="mb-4"
  />
  <div class="mb-3">
    <span class="badge bg-soft-primary text-primary font-14 px-3 py-2">
      <i class="ri-code-s-slash-line me-1"></i>
      {{ "layout.aboutModal.version" | translate }} 2.22.5
    </span>
    <p class="text-muted mb-0">
      <i class="ri-calendar-line me-1"></i>
      {{ "layout.aboutModal.releaseDate" | translate }} 30/10/2026
    </p>
  </div>
  <a [href]="supportUrl" target="_blank" class="btn btn-soft-success btn-sm">
    <i class="mdi mdi-whatsapp me-1"></i>
    {{ "layout.aboutModal.contactSupport" | translate }}
  </a>
</div>
<div class="modal-footer">
  <button class="btn btn-light" (click)="close()">
    {{ "layout.aboutModal.close" | translate }}
  </button>
</div>
